export default "__VITE_ASSET__CvZpf0sj__"